import { HttpContextToken } from '@angular/common/http';

export const BYPASS_ERROR = new HttpContextToken(() => false);
